import { render, staticRenderFns } from "./StockByLocation.vue?vue&type=template&id=2d1a6c0d"
import script from "./StockByLocation.vue?vue&type=script&lang=js"
export * from "./StockByLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports